export default "__VITE_ASSET__7a279b38__"